
import { Component, Vue } from 'vue-property-decorator';
import BaseCurrencyAmount from '@/components/BaseCurrencyAmount.vue';
import { SalesQuote } from '@/api';

interface Totals {
  [key: string]: number;
}

@Component({
  components: { BaseCurrencyAmount },
})
export default class NewClaimFooterTotals extends Vue {
  get agreement(): SalesQuote | undefined {
    return this.$store.getters['claim/agreement'];
  }

  get totals(): Totals {
    return this.$store.getters['claim/calculateClaimTotals'];
  }
}
